<template>
  <section ref="root" class="dc-container">
    <!-- papel rasgado -->
    <div class="rasgado rasgado-top"></div>

    <!-- CONTENIDO -->
    <div class="dc-card">
      <!-- Título en dos líneas -->
      <h2 ref="title" class="dc-title">
        <span>Código</span><br />
        <span class="script">de Vestimenta</span>
      </h2>

      <!-- Etiqueta -->
      <div ref="badge" class="dc-badge">ELEGANTE FORMAL</div>

      <!-- Ilustración vestido / traje -->
      <img
        ref="figure"
        src="@/assets/codigo.png"
        alt="Código de vestimenta"
        class="dc-figure"
      />

      <!-- Nota -->
      <p ref="note" class="dc-note">
        Reservamos los colores verde esmeralda, dorado y verde olivo exclusivamente para la Quinceañera.
      </p>

      <!-- SECCIÓN PALETA Y FLORES EDITORIALES -->
      <div ref="paletaWrapper" class="paleta-section-wrapper">
        <!-- Flor Izquierda y sus Ramas -->
        <div class="decoracion-lateral izq">
          <img src="@/assets/f.png" class="flor-img flor-izq" alt="" />
          <img src="@/assets/ramas.png" class="ramas-img ramas-izq" alt="" />
        </div>

        <!-- Paleta de Colores Central -->
        <img
          src="@/assets/paleta.png"
          alt="Paleta de colores"
          class="dc-paleta"
        />

        <!-- Flor Derecha y sus Ramas -->
        <div class="decoracion-lateral der">
          <img src="@/assets/f.png" class="flor-img flor-der" alt="" />
          <img src="@/assets/ramas.png" class="ramas-img ramas-der" alt="" />
        </div>
      </div>
    </div>

    <div class="rasgado rasgado-bottom"></div>
  </section>
</template>

<script>
import { ref, onMounted, nextTick, onUnmounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'DressCodeLuxuryExact',
  setup() {
    const root = ref(null)
    const title = ref(null)
    const badge = ref(null)
    const figure = ref(null)
    const note = ref(null)
    const paletaWrapper = ref(null)

    let stInstance = null

    onMounted(async () => {
      await nextTick()

      if (!root.value) return

      // Estado inicial invisible para todo el contenedor
      gsap.set(root.value, { autoAlpha: 0, y: 30 })

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root.value,
          start: 'top 85%',
          once: true,
          onInit: (self) => { stInstance = self }
        }
      })

      // 1. Revelación suave del contenedor principal
      tl.to(root.value, {
        autoAlpha: 1,
        y: 0,
        duration: 0.6,
        ease: 'power2.out'
      })

      // 2. Título
      if (title.value) {
        tl.from(
          title.value,
          {
            opacity: 0,
            y: -20,
            filter: 'blur(6px)',
            duration: 0.5,
            ease: 'power3.out'
          },
          '-=0.3'
        )
      }

      // 3. Badge
      if (badge.value) {
        tl.from(
          badge.value,
          {
            opacity: 0,
            y: -12,
            scale: 0.95,
            duration: 0.4,
            ease: 'back.out(1.5)'
          },
          '-=0.2'
        )
      }

      // 4. Ilustración
      if (figure.value) {
        tl.from(
          figure.value,
          {
            opacity: 0,
            scale: 0.92,
            duration: 0.5,
            ease: 'power2.out'
          },
          '-=0.2'
        )
      }

      // 5. Nota descriptiva
      if (note.value) {
        tl.from(
          note.value,
          {
            opacity: 0,
            y: 12,
            duration: 0.4,
            ease: 'power2.out'
          },
          '-=0.2'
        )
      }

      // 6. ENTRADA EDITORIAL FLUIDA: Paleta, Flores y Ramas
      if (paletaWrapper.value) {
        const paletaImg = paletaWrapper.value.querySelector('.dc-paleta')
        const decoraciones = paletaWrapper.value.querySelectorAll('.decoracion-lateral')

        // Entrada sutil de la paleta
        tl.from(
          paletaImg,
          {
            opacity: 0,
            y: 15,
            duration: 0.6,
            ease: 'power2.out'
          },
          '-=0.1'
        )

        // Despliegue orgánico y suave de flores + ramas en conjunto
        tl.fromTo(
          decoraciones,
          {
            opacity: 0,
            y: 20,
            scale: 0.92,
            filter: 'blur(4px)'
          },
          {
            opacity: 1,
            y: 0,
            scale: 1,
            filter: 'blur(0px)',
            duration: 0.8,
            stagger: 0.15,
            ease: 'power3.out'
          },
          '-=0.4'
        )
      }
    })

    onUnmounted(() => {
      if (stInstance) stInstance.kill()
      ScrollTrigger.refresh()
    })

    return { root, title, badge, figure, note, paletaWrapper }
  }
}
</script>

<style scoped>
.dc-container {
  position: relative;
  max-width: 500px;
  margin: 0 auto;
  background: #a4bcac;
  padding: 34px 18px 50px;
  overflow: visible;
  text-align: center;
  will-change: transform, opacity;
}

/* Rasgados */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  overflow: visible;
  height: 40px;
  background: #a4bcac;
  z-index: 1;
  pointer-events: none;
}
.rasgado-top {
  top: 0;
  clip-path: polygon(0% 70%, 18% 55%, 38% 78%, 58% 52%, 78% 75%, 100% 60%, 100% 0%, 0% 0%);
}
.rasgado-bottom {
  bottom: 0;
  clip-path: polygon(0% 30%, 18% 45%, 38% 22%, 58% 48%, 78% 25%, 100% 40%, 100% 100%, 0% 100%);
}

.dc-card {
  position: relative;
  z-index: 2;
}

.dc-title {
  font-family: 'britishgruesa', cursive;
  font-size: 66px;
  color: #ffffff;
  margin: 0 0 16px;
  line-height: 1.05;
}
.dc-title .script {
  font-weight: 400;
  opacity: 0.9;
}

.dc-badge {
  display: inline-block;
  background: #f6f4f4;
  color: #2f2d2d;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 18px;
  letter-spacing: 0.14em;
  padding: 8px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  margin: 4px 0 12px;
}

.dc-figure {
  width: 200px;
  height: auto;
  display: block;
  margin: 10px auto 12px;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.15));
}

.dc-note {
  font-family: 'quote', serif;
  font-size: 22px;
  color: #ffffff;
  opacity: 0.9;
  font-style: italic;
  margin: 10px auto 18px;
}

/* ================= SECCIÓN PALETA Y FLORES ================= */
.paleta-section-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 25px;
  padding: 0 10px;
}

.dc-paleta {
  width: min(100%, 250px);
  height: auto;
  display: block;
  z-index: 2;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.12));
}

.decoracion-lateral {
  position: absolute;
  top: -595px; /* Posicionamiento natural al nivel de la paleta */
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1;
  pointer-events: none;
  will-change: transform, opacity, filter;
}

.decoracion-lateral.izq {
  left: -30px !important;
}

.decoracion-lateral.der {
  right: -30px !important;
}

.flor-img {
  width: 110px !important;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.1));
}

.flor-der {
  transform: scaleX(-1);
}

.ramas-img {
  width: 85px;
  height: auto;
  object-fit: contain;
  margin-top: -56px !important;
  opacity: 0.85;
}

.ramas-der {
  transform: scaleX(-1);
}

</style>